import * as React from 'react';
import AttachmentPreferencesFull from './components/AttachmentPreferencesFull';
import isAttachmentPreferencesOptionDirty from './utils/isAttachmentPreferencesOptionDirty';
import discardAttachmentPreferencesOption from './actions/discardAttachmentPreferencesOption';
import saveAttachmentPreferencesOption from './actions/saveAttachmentPreferencesOption';
var AttachmentPreferencesOption = {
    key: 'attachmentPreferences',
    titleStringKey: 'optionTitle_attachmentPreferences',
    searchTermsStringKey: 'optionTitle_attachmentPreferences',
    fullOptionFormSettings: {
        render: function () { return React.createElement(AttachmentPreferencesFull, null); },
        isDirty: isAttachmentPreferencesOptionDirty,
        onSave: saveAttachmentPreferencesOption,
        onDiscard: discardAttachmentPreferencesOption,
    },
};
export default AttachmentPreferencesOption;
//# sourceMappingURL=AttachmentPreferencesOption.js.map